import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { isEmpty } from 'lodash'
import clsx from 'clsx'
import { Alert } from '@material-ui/lab'
import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core'

import { BaseDialog } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import schema from './schema'
import useStyles from './styles'
import theme from 'theme'

const DownloadVersionDialog = ({
  open,
  setOpen,
  downloadDocument = async () => {},
}) => {
  const [loading, setLoading] = useState(false)

  const classes = useStyles()
  const snackbar = useSnackbar()

  const { control, errors, watch, handleSubmit } = useForm({
    validationSchema: schema,
    defaultValues: {
      versionOption: 'current',
    },
  })

  const current = watch('versionOption')

  const isNew = current === 'new'

  const handleCloseDialog = () => setOpen(null)

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      const isCurrent = data?.versionOption === 'current'

      if (isCurrent) {
        const file = await helpers.file.fromUrl(
          open?.documentVersion?.attachment?.url,
          open?.documentVersion?.attachment?.name,
        )
        helpers.file.handleOpen(file)
      } else {
        await downloadDocument(open?.documentVersion?.id)
      }

      handleCloseDialog()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Não foi possível baixar o documento.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={!isEmpty(open)}
      onClose={handleCloseDialog}
      title="Baixar a versão do documento"
      actionButtonText="Baixar"
      closeButtonText="Cancelar"
      actionButton={handleSubmit(onSubmit)}
      dialogSize="md"
      fullWidth
      loading={loading}
      closeButtonAction={handleCloseDialog}
    >
      <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
        {isNew && (
          <Alert severity="info">
            Ao emitir um novo documento, ele será gerado com a data e hora de
            emissão atualizadas e poderá refletir melhorias de layout aplicadas
            da plataforma.
          </Alert>
        )}
        <FormControl error={!!errors?.versionOption} fullWidth>
          <FormLabel>Escolha qual documento deseja baixar:</FormLabel>
          <Controller
            name="versionOption"
            control={control}
            as={
              <RadioGroup
                row
                className={clsx({
                  [classes.error]: !!errors?.versionOption,
                })}
              >
                <FormControlLabel
                  value="current"
                  control={
                    <Radio
                      color="primary"
                      className={clsx({
                        [classes.error]: !!errors?.versionOption,
                      })}
                    />
                  }
                  label="Versão atual"
                />
                <FormControlLabel
                  value="new"
                  control={
                    <Radio
                      color="primary"
                      className={clsx({
                        [classes.error]: !!errors?.versionOption,
                      })}
                    />
                  }
                  label="Emitir um novo"
                />
              </RadioGroup>
            }
          />
          {errors?.versionOption && (
            <FormHelperText error>
              {errors.versionOption.message}
            </FormHelperText>
          )}
        </FormControl>
      </Box>
    </BaseDialog>
  )
}

export default DownloadVersionDialog
